import { defineMessages } from 'utils/intl';

export default defineMessages({
  title: 'Kontakt',
  descriptionTitle: 'Masz pytania? Chcesz wiedzieć więcej? Zadzwoń lub napisz do nas.',
  description: 'Poszukujesz szkolenia IT, a nie znalazłeś go na naszej stronie? Koniecznie daj nam znać!',
});
